import { AccordionAndTextProps } from "@made-people/blueprint-accordion-and-text";

export const AccordionAndText: AccordionAndTextProps = {
  template: "template1",
  layout: {
    spacing: {
      y: {
        initial: "xl",
        md: "2xl",
        lg: "3xl",
      },
    },
  },
  accordion: {
    layout: {
      spacing: {
        applySpacing: "false",
      },
    },
  },
  variants: {
    layout: {
      initial: "vertical",
      lg: "horizontal",
    },
  },
  heading: {
    variants: {
      headingSize: {
        initial: "lg",
        lg: "xl",
      },
    },
  },
};
